import React from 'react'
import Tabs from '@material-ui/core/Tabs'
import Tab from '@material-ui/core/Tab'
import { makeStyles } from '@material-ui/core/styles'

const useStylesTabs = makeStyles(() => ({
  root: {
    //marginBottom: '-10px',
    overflow: 'initial',
  },
  scroller: {
    overflow: 'initial !important',
  },
  indicator: {
    backgroundColor: '#4AA652',
    bottom: '-6px',
    height: '2px',
    borderRadius: '1px 1px 0px 0px',
  },
}))

const useStyles = makeStyles(() => ({
  root: {
    minWidth: 'auto',
    marginRight: '45px',
    paddingRight: '5px',
    paddingLeft: '5px',
    display: 'flex',
    justifyContent: 'center',
    '&:last-child': {
      marginRight: '0',
    },
  },
  textColorPrimary: {
    fontFamily: 'Source Sans Pro',
    fontStyle: 'normal',
    fontWeight: 400,
    fontSize: '16px',
    lineHeight: '20px',
    color: '#151F31',
    textTransform: 'none',

    '&.Mui-selected': {
      color: '#151F31',
      letterSpacing: ' 0.01em',
    },
  },
  selected: {
    fontWeight: 600,
    // color: '#151F31',
  },
}))

const TabStyled = ({ tabs = [], handleChangeTab }) => {
  const classesTabs = useStylesTabs()
  const classes = useStyles()
  const [value, setValue] = React.useState(2)

  const handleChange = (event, index) => {
    setValue(index)
    if (typeof handleChangeTab === 'function') {
      handleChangeTab(tabs[index].value)
    }
  }
  return (
    <Tabs
      value={value}
      indicatorColor="primary"
      textColor="primary"
      onChange={handleChange}
      classes={classesTabs}
    >
      {tabs.map((t, i) => {
        return (
          <Tab
            label={t.label}
            key={i}
            classes={classes}
            disabled={t.disabled}
          />
        )
      })}
    </Tabs>
  )
}

export default TabStyled
